import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import React from "react";
import { MAutocomplete, ResponsiveFormContainer } from "@app/components";
import { useFormContext } from "react-hook-form";
import PrepararionFineForm from "./prepararionFineForm";
import PrepararionGrossForm from "./prepararionGrossForm";
import { useEquipment, useUser } from "@services/servicesGenericsTables";

const PreparationSR = () => {
  const form = useFormContext();
  const { currentPreparation } = useAnalysis();
  const { userList } = useUser();
  const { equipmentList } = useEquipment();

  /*   const configComponent = {
    1: <PrepararionGrossForm />,
    2: <PrepararionFineForm />,
  }; */

  return (
    <>
      {currentPreparation.index !== undefined && (
        <>
          {/*         <ResponsiveFormContainer columns={5} mb={2}>
            <MAutocomplete
              key={JSON.stringify(form.getValues("typeSeparation"))}
              name="typeSeparation"
              options={TYPE_SR}
              getOptionLabel={(option) => option.label || ""}
              label="Seleccione una separación"
              validation={{ required: "La separación es requerida" }}
              disabled={currentPreparation.id !== undefined}
            />
          </ResponsiveFormContainer>

          {watchTypeSeparation && ( */}
          <ResponsiveFormContainer columns={5}>
            <MAutocomplete
              key={JSON.stringify(form.getValues("analysis_analyst"))}
              name="analysis_analyst"
              options={userList}
              label="Seleccione un analista"
              getOptionLabel={(option) => option.username || ""}
              validation={{ required: "El analista es requerido" }}
              disabled={!currentPreparation.canEdit}
            />
            <MAutocomplete
              key={JSON.stringify(form.getValues("analysis_equipment"))}
              name="analysis_equipment"
              options={equipmentList}
              label="Seleccione un Equipo"
              getOptionLabel={(option) =>
                `${option.codigo} - ${option.descripcion}` || ""
              }
              validation={{ required: "El equipo es requerido" }}
              multiple={true}
              disabled={!currentPreparation.canEdit}
            />
          </ResponsiveFormContainer>
          {/*   )}
          {watchTypeSeparation && configComponent[watchTypeSeparation.value]} */}
          <PrepararionGrossForm />
          <PrepararionFineForm />
        </>
      )}
    </>
  );
};

export default PreparationSR;
